<template>
  <div class="option" v-if="message.type === 'Option'">
    <!--card style-->
    <div class="card" v-if="parentLayout === 'card' || parentLayout === 'gpt'">
      <div class="option-items">
        <div
          class="item"
          v-for="(item, index) in JSON.parse(message.content).data"
          :key="index"
        >
          <div
            class="item-image"
            v-if="item.editData.imageUrl"
            :style="`backgroundImage:url('${
              baseUrl + item.editData.imageUrl
            }')`"
          ></div>
          <div v-else class="item-default-image"></div>
          <div class="item-infos">
            <div class="title">{{ item.editData.title }}</div>
            <div class="sub-title">{{ item.editData.subTitle }}</div>
            <div
              class="buttonText"
              :class="{ disabled: isFinished }"
              @click="createOptionSelectMessage(item)"
            >
              {{ item.editData.buttonText || "Select" }}
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--除了 card/gpt style 以外 只能是 link style-->
    <div class="link" v-else>
      <div class="option-items">
        <div
          class="desc gpt-ql-editor"
          v-html="JSON.parse(message.content).desc"
        ></div>
        <div
          tabindex="0"
          :aria-label="item.editData.title"
          class="item"
          :class="{ disabled: isFinished }"
          v-for="(item, index) in filterOptions"
          :key="index"
          @click="createOptionSelectMessage(item)"
          @keyup.enter="createOptionSelectMessage(item)"
        >
          {{ item.editData.title }}
        </div>
        <div class="item" v-if="filterOptions.length === 0">
          No services yet.
        </div>
      </div>
    </div>
    <div class="time">{{ message.createAt | localTime }}</div>
  </div>
</template>

<script>
export default {
  name: "gpt-message-options",
  props: {
    message: {
      type: Object,
    },
  },
  data() {
    return {
      baseUrl: process.env.VUE_APP_BASEURL,
    };
  },
  methods: {
    // 送出我選擇的服務項目 (Customer)
    async createOptionSelectMessage(item) {
      if (this.isFinished) {
        return;
      }
      window.dataLayer.push({
        event: "data_layer_event",
        chatbot_session_id: this.chatbot_session_id,
        event_name_ga4: "click_menu_genio",
        event_category_DL: "genio",
        event_action_DL: "clicked",
        event_label_DL: `${item.editData.title}/click_menu`,
      });
      // console.log("送出我選擇的服務項目", item);
      // const { botKeyName } = item.editData;
      // const parentBotKeyName = this.findParentBotKeyName(item.parentId);
      const data = {
        type: "OptionSelect",
        chatUserRole: "Customer",
        content: JSON.stringify({ title: item.title }),
      };
      try {
        await this.$store.dispatch("gpt/createMessage", data);
        if (item.editData.isTutorial) {
          const data = {
            type: "Tutorial",
            chatUserRole: "System",
            content: JSON.stringify(item.editData),
          };
          this.$store.commit("gpt/setBotRender", {
            BotScope: item.editData.chatGPTUrl,
            id: item.id,
          });
          this.$store.dispatch("gpt/createMessage", data);
        } else if (
          item.editData.botKeyName === "inquire-product-warranty-period"
        ) {
          this.$store.commit("gpt/setBotRender", {
            chatType: "Warranty and Policy",
            chatType2: "inquire-product-warranty-period",
            BotScope: "warranty", // 似乎無用 暫時寫死
          });
          this.$store.dispatch(
            "gpt/createBotSettingMessage",
            "ChatGPT_Warranty_SnNo_Input"
          );
        } else if (item.editData.botKeyName === "inquire-repair-status") {
          this.$store.commit("gpt/setBotRender", {
            chatType: "Repair Service",
            chatType2: "inquire-repair-status",
            BotScope: "repair", // 似乎無用 暫時寫死
          });
          this.$store.dispatch(
            "gpt/createBotSettingMessage",
            "ChatGPT_Repair_SnNo_Input"
          );
        } else if (item.editData.isToAgent) {
          const editData = item.editData;
          let data = {
            type: "ToAgent",
            chatUserRole: "System",
            content: "",
          };

          //情境 1. 只純粹轉真人
          if (
            !this.botRoom.isServiceTime &&
            this.botRoom.isSingleServiceTime &&
            editData.isToAgentNonService
          ) {
            // 非服務時間時+有設定isToAgentNonService
            // AP-4871 緊急事件
            data.type = "NonService";
            data.content = editData.toAgentNonServiceDesc;
          } else {
            // 一般的 ToAgent
            // 營業: 吃editData.toAgentDesc
            // 非營業: 吃系統共用 setting.ChatGPT_NonService_Reply
            data.type = "ToAgent";
            data.content = editData.toAgentDesc;
          }
          this.$store.dispatch("gpt/createMessage", data);
        } else if (item.items.length) {
          //情境 2. 選擇的項目有 child，送出選單(以及其layout)
          const data = {
            parentLayout: item.editData.layout,
            desc: item.editData.desc,
            data: item.items,
          };
          this.$store.dispatch("gpt/createOptionMessage", data);
        } else if (item.editData.chatGPTUrl) {
          // 情境 3. 有 chatGPTUrl
          this.createProductReply(item.editData.chatGPTUrl, item.id);
        } else {
          // 情境 4. 都是意圖 不是 skill 也不是 技術支援
          this.$store.dispatch(
            "gpt/handleReturnMessage",
            item.editData.botKeyName
          );
        }
      } catch (error) {
        console.log("catch", error);
      }
    },
    // 送出 產品線回覆
    async createProductReply(chatGPTUrl, id) {
      // 設定BOT參數
      // console.log("createProductReply", chatGPTUrl, id);
      // id = 找決策樹要用的
      this.$store.commit("gpt/setBotRender", {
        BotScope: chatGPTUrl,
        id: id,
      });
      await this.$store.dispatch(
        "gpt/createBotReplyMessage",
        "ChatGPT_ProductReply"
      );
    },
    findParentBotKeyName(parentId) {
      let target;
      const find = (items) => {
        if (!items.length) return;
        items.forEach((el) => {
          if (el.id === parentId) {
            target = el;
          } else {
            find(el.items);
          }
        });
      };
      find(this.tree[0].items);

      if (target) {
        return target.editData.botKeyName;
      } else {
        return "";
      }
    },
  },
  computed: {
    filterOptions() {
      const options = JSON.parse(this.message.content).data;
      return options.filter((el) => el.editData.isEnabled);
    },
    parentLayout() {
      return JSON.parse(this.message.content).parentLayout;
    },
    isFinished() {
      return this.$store.state.gpt.botRoom.isFinished;
    },
    botRoom() {
      return this.$store.state.gpt.botRoom;
    },
    tree() {
      return this.$store.state.gpt.tree;
    },
    chatbot_session_id() {
      return this.$store.getters["gpt/chatbot_session_id"];
    },
  },
};
</script>

<style lang="scss" scoped>
@import "gpt.scss";
</style>
